module.exports = __webpack_public_path__ + "img/zh.daa4b5a7.svg";